export default __webpack_public_path__ + "static/media/bonus-star.a658cecc.svg";